<div class="container-fluid ecommerce-dashboard-page dashboard-page">
    <div class="page-controls">
        <div class="period-block">
            <div class="section-label">Period</div>
            <p-selectButton (onChange)="onPeriodChange($event.value)"
                            [allowEmpty]="false"
                            [ngModel]="selectedPeriod$ | async"
                            [options]="periodOptions"
                            class="period-select"
                            optionLabel="label"
                            optionValue="value"></p-selectButton>
        </div>
    </div>

    @let banner = livePaymentsBanner;
    <div [class]="'live-payments-banner card live-payments-banner--' + banner.tone">
        <div class="card-body">
            <div class="live-payments-header">
                <span class="live-payments-icon"><i [class]="banner.icon"></i></span>
                <div class="live-payments-copy">
                    <h5 class="live-payments-title">{{ banner.title }}</h5>
                    <p class="live-payments-subtitle">{{ banner.subtitle }}</p>
                </div>
                @if (banner.showSetupGuide) {
                    <a [href]="setupGuideLink"
                       class="live-payments-toggle"
                       rel="noopener noreferrer"
                       target="_blank">View setup guide</a>
                } @else {
                    <a [href]="supportPortalUrl"
                       class="live-payments-toggle"
                       rel="noopener noreferrer"
                       target="_blank">Get Help</a>
                }
            </div>
            @if (externalIdentifier) {
                <div class="live-payments-identifier">
                    <span class="live-payments-identifier-label">External Identifier</span>
                    <code class="live-payments-identifier-value">{{ externalIdentifier }}</code>
                    <button (click)="copyExternalIdentifier()"
                            [pTooltip]="copiedField === 'externalIdentifier' ? 'Copied!' : 'Copy External Identifier'"
                            aria-label="Copy External Identifier"
                            class="live-payments-identifier-copy"
                            type="button">
                        <i [ngClass]="copiedField === 'externalIdentifier' ? 'fa fa-check' : 'fa fa-copy'"></i>
                    </button>
                    <span class="live-payments-identifier-hint">
                        Paste this into your store's Pay@ Gateway settings to link your store to this account.
                    </span>
                </div>
            } @else if (externalIdentifierUnavailable) {
                <div class="live-payments-identifier">
                    <span class="live-payments-identifier-label">External Identifier</span>
                    <code class="live-payments-identifier-value">Unavailable</code>
                    <span class="live-payments-identifier-hint">
                        We couldn't load your external identifier. Please refresh the page to try again.
                    </span>
                </div>
            }
        </div>
    </div>

    <div class="balance-bar card">
        <div class="card-body">
            <div class="balance-bar-header">
                <h5 class="balance-bar-title">E-Commerce Settlement Overview</h5>
                <a [routerLink]="settlementListPath" class="navy-btn view-settlements-btn">View Settlements</a>
            </div>
            <div class="balance-bar-tiles">
                @let balance = (balanceSummary$ | async);
                @let unavailable = !balance;
                @let hasPending = !unavailable && balance?.expectedSettlementDate != null;
                <!--                <app-balance-tile label="Awaiting Settlement"-->
                <!--                                  [tooltipText]="awaitingSettlementTooltip(balance)"-->
                <!--                                  [value]="(balance?.pendingTotalAvailable ?? 0) | toMajor | currency:'R '"-->
                <!--                                  [description]="hasPending ? 'All pending batches' : 'No settlement pending'"-->
                <!--                                  [empty]="!hasPending"-->
                <!--                                  [unavailable]="unavailable"></app-balance-tile>-->
                <app-balance-tile [description]="hasPending ? ('Settles on ' + formatSettlementDate(balance?.expectedSettlementDate)) : 'No settlement pending'"
                                  [empty]="!hasPending"
                                  [tooltipText]="availableForSettlementTooltip(balance)"
                                  [unavailable]="unavailable"
                                  [value]="(balance?.availableForSettlement ?? 0) | toMajor | currency:'R '"
                                  label="Available for Settlement"></app-balance-tile>
                <app-balance-tile [description]="feesAndDeductionsDescription(balance)"
                                  [empty]="!hasPending"
                                  [tooltipText]="feesAndDeductionsTooltip(balance)"
                                  [unavailable]="unavailable"
                                  [value]="(balance?.totalDeductionsInclVat ?? 0) | toMajor | currency:'R '"
                                  label="Fees & Deductions"></app-balance-tile>
            </div>
        </div>
    </div>

    <div class="store-row card">
        <div class="card-body store-row-body">
            <div class="store-block store-block--active">
                <label class="section-label" for="ecommerceStoreSelect">Active Store</label>
                <div class="store-select-row">
                    <p-select (onChange)="onStoreChange($event.value)"
                              [disabled]="!hasStores"
                              [ngModel]="selectedStoreId$ | async"
                              [options]="storeOptions"
                              class="pill-select store-select"
                              inputId="ecommerceStoreSelect"
                              optionLabel="label"
                              optionValue="value"
                              placeholder="All Stores">
                        <ng-template #selectedItem let-option>
                            <span class="store-select-value">{{ selectedStore?.domain || option?.label }}</span>
                        </ng-template>
                    </p-select>
                    @let verification = storeVerification;
                    @if (verification) {
                        <i [attr.aria-label]="verification.label"
                           [class]="'store-verification-icon ' + verification.iconClass"
                           [pTooltip]="verification.label + ' - ' + verification.detail"
                           role="img"
                           tabindex="0"></i>
                    }
                </div>
            </div>

            @if (!hasStores && availableStoresToAdd.length > 0 && canManageECommerceStoreCredentials) {
                <div [formGroup]="addStoreForm" class="add-store-controls">
                    <div class="store-block">
                        <label class="section-label" for="ecommerceStoreAddSelect">Add Store</label>
                        <p-select [options]="availableStoresToAdd"
                                  class="pill-select store-select"
                                  formControlName="store"
                                  inputId="ecommerceStoreAddSelect"
                                  optionLabel="storeName"
                                  placeholder="Select a Store"></p-select>
                    </div>
                    <div class="store-block">
                        <label class="section-label"
                               for="dashboardECommerceStoreDomain">Storefront Domain</label>
                        <validation [formGroup]="addStoreForm"
                                    controlName="domain"
                                    displayName="Storefront domain">
                            <input class="store-domain-input"
                                   formControlName="domain"
                                   id="dashboardECommerceStoreDomain"
                                   maxlength="255"
                                   placeholder="example.com"
                                   type="text"/>
                        </validation>
                    </div>
                    <div class="store-block">
                        <label class="section-label"
                               for="dashboardECommerceStoreDescription">Description (Optional)</label>
                        <validation [formGroup]="addStoreForm"
                                    controlName="description"
                                    displayName="Description">
                            <input class="store-domain-input"
                                   formControlName="description"
                                   id="dashboardECommerceStoreDescription"
                                   maxlength="255"
                                   placeholder="e.g. Main online store"
                                   type="text"/>
                        </validation>
                    </div>
                    <div class="store-block store-block--action">
                        <span aria-hidden="true" class="section-label label-spacer"></span>
                        <button (click)="addStore()"
                                [disabled]="addStoreForm.invalid || addingStore"
                                class="navy-btn add-store-btn"
                                type="button">
                            Add Store <i [hidden]="!addingStore" class="fa fa-spinner fa-spin"></i>
                        </button>
                    </div>
                </div>
                <div class="add-store-note-row">
                    <div class="alert alert-info add-store-note">
                        <i class="fas fa-info-circle"></i>
                        Your keys will only work on the domain you enter here.
                        We check every new store before it can go live, so it cannot take payments until that
                        check is done.
                    </div>
                </div>
            }

            @if (selectedStore && canManageECommerceStoreCredentials) {
                <div class="cred-panel">
                    <div class="cred-row">
                        <span class="section-label cred-label">Public Key</span>
                        <code class="cred-value">
                            <span class="cred-value-text">{{ getDisplayedPublicKey() }}</span>
                        </code>
                        <button (click)="togglePublicKey()"
                                [pTooltip]="publicKeyVisible ? 'Hide public key' : 'Show full public key'"
                                class="cred-icon-btn"
                                type="button">
                            <i [ngClass]="publicKeyVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                        </button>
                        <button (click)="copyKey('public')"
                                [disabled]="!selectedStore.publicKey"
                                [pTooltip]="copiedField === 'public' ? 'Copied!' : 'Copy public key'"
                                class="cred-icon-btn"
                                type="button">
                            <i [ngClass]="copiedField === 'public' ? 'fa fa-check' : 'fa fa-copy'"></i>
                        </button>
                    </div>

                    <div class="cred-row">
                        <span class="section-label cred-label">Secret Key</span>
                        <code class="cred-value">
                            <span class="cred-value-text">{{ secretKeyVisible ? (selectedStore.secretKey || '-') : '••••••••••••••••' }}</span>
                        </code>
                        <button (click)="toggleSecretKey()"
                                [pTooltip]="secretKeyVisible ? 'Hide secret' : 'Show secret'"
                                class="cred-icon-btn"
                                type="button">
                            <i [ngClass]="secretKeyVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                        </button>
                        <button (click)="copyKey('secret')"
                                [disabled]="!selectedStore.secretKey"
                                [pTooltip]="copiedField === 'secret' ? 'Copied!' : 'Copy secret key'"
                                class="cred-icon-btn"
                                type="button">
                            <i [ngClass]="copiedField === 'secret' ? 'fa fa-check' : 'fa fa-copy'"></i>
                        </button>
                    </div>
                </div>
            }

            @if (selectedStore && canOpenStoreSettings) {
                <a [routerLink]="accountSettingsPath" class="settings-link" fragment="ecommerce-config">
                    <i class="fa fa-cog"></i>
                    <span>Store Settings</span>
                    <i class="fa fa-arrow-right"></i>
                </a>
            }
        </div>
    </div>

    <div class="stats-row">
        @let stats = (stats$ | async);
        @let statsUnavailable = !stats;
        <app-stat-tile [isCompact]="true"
                       [unavailable]="statsUnavailable"
                       [value]="(stats?.totalSales ?? 0) | toMajor | currency:'R '"
                       label="Total Sales"
                       tooltipText="Total value of paid transactions in this period."></app-stat-tile>
        <app-stat-tile [isCompact]="true"
                       [unavailable]="statsUnavailable"
                       [value]="((averageOrderValue$ | async) ?? 0) | toMajor | currency:'R '"
                       label="Average Order Value"
                       tooltipText="Average value of a paid transaction in this period."></app-stat-tile>
        <app-stat-tile [isCompact]="true"
                       [unavailable]="statsUnavailable"
                       [value]="stats?.transactionVolume ?? 0"
                       label="Transaction Volume"
                       tooltipText="Number of transactions in this period, paid or not."></app-stat-tile>
        <app-stat-tile [isCompact]="true"
                       [unavailable]="statsUnavailable"
                       [value]="(((conversionRatePercent$ | async) ?? 0) | number:'1.0-1') + '%'"
                       label="Conversion Rate"
                       tooltipText="Percentage of transactions in this period that were paid."></app-stat-tile>
        <app-stat-tile [isCompact]="true"
                       [unavailable]="statsUnavailable"
                       [value]="stats?.expiredCount ?? 0"
                       label="Expired"
                       tooltipText="Transactions in this period that ran out of time before being paid."></app-stat-tile>
        <app-stat-tile [isCompact]="true"
                       [unavailable]="statsUnavailable"
                       [value]="stats?.cancelledCount ?? 0"
                       label="Cancelled"
                       tooltipText="Transactions in this period cancelled by the customer or your store before payment."></app-stat-tile>
    </div>

    <div class="recent-transactions card">
        <div class="card-body">
            <div class="recent-transactions-header">
                <h5 class="section-title">Recent Transactions</h5>
            </div>
            <app-ecommerce-account-table [accounts]="recentTransactions$ | async"
                                         [loading]="(recentLoading$ | async) ?? false"
                                         [error]="(recentError$ | async) ?? false"
                                         [clientSideSort]="true"
                                         [sortField]="defaultSortField"
                                         [sortOrder]="defaultSortOrder"
                                         [menuItemsForAccount]="buildMenuItemsForAccount"
                                         [storesById]="storesById"></app-ecommerce-account-table>

            <div class="recent-transactions-footer">
                <a [routerLink]="ecommerceListPath" class="navy-btn view-all-btn">View All Transactions</a>
            </div>
        </div>
    </div>
</div>
